import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { urls } from '../../common/model/properties';
import { SecureStorageService } from '../../secure-storage.service';
import { CupService } from '../../shared/services/cup.service';

@Injectable()
export class memberClinicalCommunicationService {
  constructor(
    private http: HttpClient,
    private cupService: CupService,
    private secureStorage: SecureStorageService
  ) {}

  getMemberdata(name, date): Observable<any> {
    // const token: any = this.secureStorage.getSecureInfoInLocalStorage('clientCredentials_token');
    // const headers = new HttpHeaders({
    //    'Content-Type': 'application/json',
    //    'Authorization': 'Bearer ' + token
    // });
    const ppjwt = JSON.parse(
      this.secureStorage.getSecureInfoInLocalStorage('currentUser')
    );
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + ppjwt.access_token,
    });

    let myParams = new HttpParams()
      //  .append('username', name)
      .append('datelimit', date);
    return this.http.get(urls.getmemberData, {
      headers: headers,
      params: myParams,
    });
  }

  getMemberStatusChanged(id): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    let myParams = new HttpParams().append('memberUid', id);
    return this.http.get(urls.majorStatusChange, {
      headers: headers,
      params: myParams,
    });
  }

  getmemberMedicationData(id, datelimit, memberId) {
    console.log('1');
    const ppjwt = JSON.parse(
      this.secureStorage.getSecureInfoInLocalStorage('currentUser')
    );
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + ppjwt.access_token,
    });
    let myParams = new HttpParams()
      .append('memberUid', id)
      .append('datelimit', datelimit);

    const payload = {
      memberUID: id,
      dateLimit: datelimit,
      // memberId: memberId,
    };
    //return this.http.get(urls.memberMedicationData, { headers: headers,observe:'response', params: myParams });
    return this.http.post(urls.memberMedicationData, payload, {
      headers: headers,
      observe: 'response',
    });
  }
  getPDFPrintData(
    medicationData,
    admitDischargeData,
    clinicalSummaryData,
    selectedduration
  ) {
    const allResponses = [];
    allResponses.push(
      this.getmemberMedicationData2(medicationData, selectedduration)
    );
    allResponses.push(
      this.getinPatientData2(admitDischargeData, selectedduration)
    );
    allResponses.push(this.getPersonId2(clinicalSummaryData));
    return allResponses;
  }
  getClinicalAndReason(payloadArray) {
    const allResponses = [];
    allResponses.push(this.getMemberClinicalAndReasonForVisit2(payloadArray));
    return allResponses;
  }

  getMemberClinicalAndReasonForVisit2(payloadArray) {
    const apis = [];
    const ppjwt = JSON.parse(
      this.secureStorage.getSecureInfoInLocalStorage('currentUser')
    );
    const headers1 = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + ppjwt.access_token,
    });



    if (payloadArray.length > 0) {
      payloadArray.map((element) => {
        apis.push(
          this.http
            .post(urls.getReasonForVisit, element.payload, {
              headers: headers1,
              observe: 'response',
            })
            .pipe(catchError((err) => of(err.status)))
        );
      });
      payloadArray.map((element) => {
        apis.push(
          this.http
            .post(urls.getClinicalSummary, element.payload, {
              headers: headers1,
              observe: 'response',
            })
            .pipe(catchError((err) => of(err.status)))
        );
      });
      return [forkJoin(apis), payloadArray];
    }
  }
  getmemberMedicationData2(medicationData, selectedduration) {
    console.log('2');
    const apis = [];
    //const headers = new HttpHeaders({'Content-Type': 'application/json'});
    const ppjwt = JSON.parse(
      this.secureStorage.getSecureInfoInLocalStorage('currentUser')
    );
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + ppjwt.access_token,
    });

    if (medicationData.length > 0) {
      medicationData.map((element) => {
        let myParams = new HttpParams()
          .append('memberUid', element.memberId)
          .append('datelimit', selectedduration);
        const payload = {
          memberUID: element.memberId,
          dateLimit: selectedduration,
          memberId: element.hmoId,
        };
        //apis.push(this.http.get(urls.memberMedicationData, { headers: headers, params: myParams })
        apis.push(
          this.http
            .post(urls.memberMedicationData, payload, { headers: headers })
            .pipe(catchError((err) => of(err.status)))
        );
      });
      return [forkJoin(apis), medicationData];
    }
  }
  getinPatientData2(admitDischargeData, selectedduration) {
    const apis = [];
    const ppjwt = JSON.parse(
      this.secureStorage.getSecureInfoInLocalStorage('currentUser')
    );
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + ppjwt.access_token,
    });
    if (admitDischargeData.length > 0) {
      admitDischargeData.map((element) => {
        let payload = {
          memberUid: element.memberId,
          datelimit: selectedduration,
          memberId: element.hmoId,
        };
        apis.push(
          this.http
            .post(urls.memberInpatientData, payload, { headers: headers })
            .pipe(catchError((err) => of(err.status)))
        );
      });
      return [forkJoin(apis), admitDischargeData];
    }
  }

  getPersonId2(clinicalSummaryData) {
    const apis = [];
    //let headers = new HttpHeaders({'Content-Type': 'application/json'});
    const ppjwt = JSON.parse(
      this.secureStorage.getSecureInfoInLocalStorage('currentUser')
    );
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + ppjwt.access_token,
    });

    if (clinicalSummaryData.length > 0) {
      clinicalSummaryData.map((element) => {
        let body = {
          memberID: element.memberId,
          memberUID: '',
        };
        apis.push(
          this.http
            .post(urls.getPersonId, body, {
              headers: headers,
              responseType: 'text',
              observe: 'response',
            })
            .pipe(catchError((err) => of(err.status)))
        );
      });
      return [forkJoin(apis), clinicalSummaryData];
    }
  }

  getClinicalFlag(id) {
    //const headers = new HttpHeaders({'Content-Type': 'application/json'});
    const ppjwt = JSON.parse(
      this.secureStorage.getSecureInfoInLocalStorage('currentUser')
    );
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + ppjwt.access_token,
    });

    let myParams = new HttpParams().append('memberID', id);
    return this.http.get(urls.getclinicalSummaryFlag, {
      headers: headers,
      params: myParams,
    });
  }

  getPersonId(id) {
    //const headers = new HttpHeaders({'Content-Type': 'application/json'});
    const ppjwt = JSON.parse(
      this.secureStorage.getSecureInfoInLocalStorage('currentUser')
    );
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + ppjwt.access_token,
    });

    let body = {
      memberID: id,
      memberUID: '',
    };
    return this.http.post(urls.getPersonId, body, {
      headers: headers,
      responseType: 'text',
      observe: 'response',
    });
  }

  getinPatientData(memberdetails, datelimit) {
    //const headers = new HttpHeaders({'Content-Type': 'application/json'});
    const ppjwt = JSON.parse(
      this.secureStorage.getSecureInfoInLocalStorage('currentUser')
    );
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + ppjwt.access_token,
    });

    const payload = {
      memberUID: memberdetails.memberId,
      memberId: memberdetails.memberHmoID,
      dateLimit: datelimit,
    };
    //return this.http.get(urls.memberInpatientData, { headers: headers,observe:'response', params: myParams });
    return this.http.post(urls.memberInpatientData, payload, {
      headers: headers,
      observe: 'response',
    });
  }
  listDocuments(kvplwithindex): any {
    const apis = [];

    const ppjwt = JSON.parse(
      this.secureStorage.getSecureInfoInLocalStorage('currentUser')
    );
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + ppjwt.access_token,
    });
    kvplwithindex.map((eachKVPL) => {
      const myParams = new HttpParams()
        .set('appId', 'PP')
        .set('documentCode', 'MEDICAL_RECORD_REVIEW')
        .set('keyValuePairList', JSON.stringify(eachKVPL.payload));
      const options = { headers: headers, params: myParams };
      apis.push(
        this.http
          .get(urls.fileNetListUrl, options)
          .pipe(catchError((err) => of(err.status)))
      );
    });
    return [forkJoin(apis), kvplwithindex];
  }
  listDocuments2(kvpl): Promise<any> {
    const ppjwt = JSON.parse(
      this.secureStorage.getSecureInfoInLocalStorage('currentUser')
    );
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + ppjwt.access_token,
    });
    const myParams = new HttpParams({
      fromObject: {
        appId: 'PP',
        documentCode: 'MEDICAL_RECORD_REVIEW',
        keyValuePairList: JSON.stringify(kvpl),
      },
    });

    const options = { headers: headers, params: myParams };
    return this.http.get(urls.fileNetListUrl, options).toPromise();
  }
  getPracticeIds() {
    const ppjwt = JSON.parse(
      this.secureStorage.getSecureInfoInLocalStorage('currentUser')
    );
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + ppjwt.access_token,
    });

    const options = { headers: headers };
    return this.http.get(urls.practseIDUrl, options);
  }
  getDocument(docID, docCode, kvpl): Observable<any> {
    const ppjwt = JSON.parse(
      this.secureStorage.getSecureInfoInLocalStorage('currentUser')
    );
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + ppjwt.access_token,
    });
    let myParams = new HttpParams({
      fromObject: {
        appId: 'PP',
        documentCode: docCode,
      },
    });
    if (kvpl !== null) {
      myParams = new HttpParams({
        fromObject: {
          appId: 'PP',
          documentCode: docCode,
          keyValuePairList: JSON.stringify(kvpl),
        },
      });
    }
    const options = { headers: headers, params: myParams };
    const urlCall =
      docID === null ? urls.filenetURL : urls.filenetURL + '/' + docID;
    return this.http.get(urlCall, options);
  }

  sendDocumentforSinglePdf(pdfData, id): Promise<any> {
    const ppjwt = JSON.parse(
      this.secureStorage.getSecureInfoInLocalStorage('currentUser')
    );
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + ppjwt.access_token,
    });
    //headers.set('Content-Type', ' ResponseContentType.Blob /json');

    //myParams.set( 'appId', 'PP' );
    let username = this.cupService.getUserNameFromJWT();
    const myParams = new HttpParams({
      fromObject: {
        userId: username,
        AuthID: id,
      },
    });
    // myParams.set( 'documentCode', "MEDICAL_RECORD_REVIEW" );
    // if ( kvpl !== null ) {
    //     myParams.set( 'keyValuePairList', JSON.stringify( kvpl ) );

    // }
    const test = {
      pdfDataContent: pdfData,
    };
    return this.http
      .post(urls.sendPdfDetails, test, {
        headers: headers,
        params: myParams,
        responseType: 'blob',
      })
      .toPromise();
  }
}
